import * as React from 'react';
import { Box, Checkbox, Paper, SortDirection } from '@mui/material';
import CustomPaginationActionsTable from '../../../../components/TablePagination';
import PaginateDataModel from '../../../../Models/PaginateDataModel';

interface CrewMobileAssetsListComponentProps {
  handlePagination: (data: any, type: string) => void;
  handleStatus: (data: any, type: string) => void;
  search?: any;
  recordList: any[];
  selectedRecords: any[];
  totalRecords: number;
  paginate: PaginateDataModel;
  orderBy: string;
  order: SortDirection;
  handleOrderBy: (columnName: any) => void;
}
const CrewMobileAssetsListComponent: React.FC<
  CrewMobileAssetsListComponentProps
> = ({
  handlePagination,
  handleStatus,
  recordList,
  selectedRecords,
  totalRecords,
  paginate,
  orderBy,
  order,
  handleOrderBy,
}) => {
  const columns: any[] = [
    {
      field: 'id',
      headerName: 'Asset Number',
      renderCell: (value: any, row: any) => (
        <Box sx={{ display: 'flex', alignItems: 'anchor-center' }}>
          <Checkbox
            edge="start"
            checked={selectedRecords.includes(value)}
            tabIndex={-1}
            disableRipple
          />

          <Box sx={{ display: 'flex', alignItems: 'anchor-center' }}>
            <small>{row.assetNumber}</small>
          </Box>
        </Box>
      ),
    },
    {
      field: 'assetName',
      headerName: 'Asset Name',
    },
    {
      field: 'isHired',
      headerName: 'Hired/Owned',
      renderCell: (value: any, row: any) => (
        <Box sx={{ display: 'flex', alignItems: 'anchor-center' }}>
          {value ? 'Hired' : 'Owned'}
        </Box>
      ),
    },
  ];
  return (
    <Paper sx={{ width: '100%' }} className="mt-4">
      <CustomPaginationActionsTable
        rows={recordList}
        columns={columns}
        totalRecords={totalRecords}
        handlePagination={(data) => {
          console.log(data);
          handlePagination(data, 'mobileasset');
        }}
        handleRowClick={(row) => {
          console.log('row-clicked');
          //   navigate('/data-management/labour/' + row.id);
          //console.log(data);
        }}
        paginationModel={{
          page: paginate.offset,
          pageSize: paginate.limit,
        }}
        handleStatus={(data: any) => {
          handleStatus(data, 'mobileasset');
        }}
        handleOrderBy={handleOrderBy}
        orderBy={orderBy}
        order={order}
      />
    </Paper>
  );
};
export default CrewMobileAssetsListComponent;
